module.exports = __webpack_public_path__ + "img/hic-neoplasm-male.06a1c1f4.png";